import { secondaryCategoryRepository } from '@webapp/core/data-access/repositories/SecondaryCategoryRepository'
import { SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'

interface UserAccessFormDefaults {
  secondaryCategoryOptions: SecondaryCategory[]
}

export const getUserAccessFormDefaults =
  async (): Promise<UserAccessFormDefaults> => {
    const result = await secondaryCategoryRepository.list()
    const secondaryCategoryOptions = result.data.map(
      (constructor) => new SecondaryCategory(constructor)
    )
    return { secondaryCategoryOptions }
  }
